var BaseView = require('../../../tool-menu/components/accordion-list/content');
var AnalyticsDecorate = require('../../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('../../../tool-menu/customize/analytics/placeholders'), BaseView.extend({
  apiCall: 'search/stickers',
  callbackName: 'callbackStickers',

  initialize: function () {
    this.debouncedMasonryReload = _.debounce(_.bind(this.masonryReload, this), 500);
    BaseView.prototype.initialize.call(this);
  },

  render: function () {
    if (!this.isAlreadyThere) {
      this.$el.closest('a').one('mousedown', _.bind(function () {
        BaseView.prototype.render.call(this);
        var $thumbnailWrapper = this.$el.find('.thumbnail-wrapper');
        this.end && this.end();
        this.tool.initScrollDetect($thumbnailWrapper, this.loadData);
      }, this));

      this.isAlreadyThere = true;
    }
  },

  initDataLoading: _.noop,

  getParams: function () {
    var params = {
      from: this.from,
      limit: this.limit,
      where: {
        isPlaceholder: true,
        active: INKIVE.C.USER.IS_SUPER ? 0 : 1
      }
    };

    this.from += this.limit;

    return params;
  },

  extractData: function (data) {
    return _.map(data, function (item) {
      var id = (this.idPrefix) ? this.idPrefix + '-' : '';
      id += 'sticker-' + item['id'];

      return {
        id: id,
        src: item['url'],
        width: 122.5,
        height: 122.5,
        cls: parseInt(item['active']) ? '' : ' grayscale',
        data: {
          count: item['count'],
          changeable: item['changeable'],
          isPlaceHolder: true
        }
      };
    }, this);
  },

  getScrollHeight: function ($target) {
    return $target.height();
  },

  getScrollWidth: function ($target) {
    return $target.width();
  }
}));
